import { useRef } from 'react'
import { useVirtual } from 'react-virtual'

import { useReactTable, getCoreRowModel, flexRender } from '@tanstack/react-table'

import { TableProps } from './types'

import { Wrap, Container, StyleTable, Header as StyledHeader, HeaderCell, RowCell, Row } from './Style'

function Table<T>({ data, columns, isStickyHeader = false }: TableProps<T>) {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  const parentRef = useRef<HTMLDivElement>(null)

  const { rows } = table.getRowModel()

  const { virtualItems, totalSize } = useVirtual({
    parentRef,
    overscan: 50,
    size: rows.length,
  })

  const paddingTop = virtualItems.length > 0 ? virtualItems[0].start || 0 : 0
  const paddingBottom = virtualItems.length > 0 ? totalSize - (virtualItems?.at(-1)?.end || 0) : 0

  return (
    <Wrap>
      <Container ref={parentRef}>
        <StyleTable>
          <thead>
            {table.getHeaderGroups().map((group) => {
              return (
                <StyledHeader key={group.id} isStickyHeader={isStickyHeader}>
                  {group.headers.map((header) => {
                    return (
                      <HeaderCell id='tableHeader' key={header.id}>
                        {flexRender(header.column.columnDef.header, header.getContext())}
                      </HeaderCell>
                    )
                  })}
                </StyledHeader>
              )
            })}
          </thead>

          <tbody>
            {paddingTop > 0 && (
              <Row>
                <RowCell style={{ height: paddingTop }} />
              </Row>
            )}

            {virtualItems.map((virtualRow) => {
              const row = rows[virtualRow.index]

              return (
                <Row key={row.id}>
                  {row.getVisibleCells().map((cell) => {
                    return <RowCell key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</RowCell>
                  })}
                </Row>
              )
            })}

            {paddingBottom > 0 && (
              <Row>
                <RowCell style={{ height: paddingBottom }} />
              </Row>
            )}
          </tbody>
        </StyleTable>
      </Container>
    </Wrap>
  )
}

export { Table }
